
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/suche/treffer",
      function () {
        return require("private-next-pages/[lang]/suche/treffer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/suche/treffer"])
      });
    }
  